import React, { useContext, useEffect } from 'react'
import {
  AdditionalInformationBlock,
  AdvantageBlock,
  CardToCardFormBlock,
  // CardToCartInfoBlock,
  DefenseBlock,
  Header,
  LimitBlock,
} from '.'

import LocalesContext from '../context/locales/context'

import { allLanguages } from '../context/locales/state'

const MainPage = () => {
  const {
    state: { selectedLanguage },
    changeLanguage,
  } = useContext(LocalesContext)

  useEffect(() => {
    const urlPathName = window.location.pathname.split('/')

    allLanguages.forEach(language => {
      if (urlPathName.includes(language)) {
        changeLanguage(language)
      }
    })
  }, [changeLanguage])

  return (
    <>
      <Header />
      <CardToCardFormBlock selectedLanguage={selectedLanguage} />
      <AdvantageBlock />
      <LimitBlock />
      <DefenseBlock />
      {/* <CardToCartInfoBlock /> */}
      <AdditionalInformationBlock />
    </>
  )
}

export default MainPage
